import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";
import NewsletterForm from "@/components/NewsletterForm";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
    const { t } = useT();
    return (
        <footer data-testid="site-footer" className="bg-forestDark text-bone/90 pt-24 pb-12 px-6 lg:px-12 mt-32">
            <div className="max-w-[1500px] mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
                    <div className="md:col-span-5">
                        <div className="eyebrow text-bone/60 mb-4">{t("footer.eyebrowBoutique")}</div>
                    </div>
                    <div className="md:col-span-3">
                        <div className="eyebrow text-bone/60 mb-4">{t("footer.visit")}</div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/cabins" className="hover:text-terracotta">{t("nav.cabins")}</Link></li>
                            <li><Link to="/experiences" className="hover:text-terracotta">{t("nav.experiences")}</Link></li>
                            <li><Link to="/story" className="hover:text-terracotta">{t("nav.story")}</Link></li>
                            <li><Link to="/gallery" className="hover:text-terracotta">{t("nav.gallery")}</Link></li>
                            <li><Link to="/contact" className="hover:text-terracotta">{t("nav.contact")}</Link></li>
                        </ul>
                    </div>
                    <div className="md:col-span-4">
                        <div className="eyebrow text-bone/60 mb-4">{t("footer.findUs")}</div>
                        <ul className="space-y-3 text-sm">
                            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-terracotta" /> Negril, Jamaica</li>
                            <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-terracotta" /> wildcoffeeretreats@gmail.com</li>
                            <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-terracotta" /> +1-876-601-0220</li>
                            <li className="flex items-start gap-3"><Instagram size={16} className="mt-0.5 text-terracotta" /> @wildcoffeeretreat</li>
                        </ul>
                    </div>
                </div>

                {/* Newsletter band */}
                <div className="border-t border-b border-bone/15 py-12 grid grid-cols-1 md:grid-cols-12 gap-10 mb-12" data-testid="footer-newsletter">
                    <div className="md:col-span-5">
                        <div className="eyebrow text-bone/60 mb-3">Newsletter</div>
                        <h3 className="font-serif text-3xl lg:text-4xl leading-tight">{t("newsletter.heading")}</h3>
                    </div>
                    <div className="md:col-span-5 md:col-start-7">
                        <p className="text-sm text-bone/70 mb-6">{t("newsletter.sub")}</p>
                        <NewsletterForm source="footer" variant="dark" />
                    </div>
                </div>

                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 text-xs text-bone/50">
                    <img src="/brand-logo.png?v=4" alt="Wild Coffee Retreat" className="h-14 w-auto" />
                    <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-6">
                        <span>© {new Date().getFullYear()} Wild Coffee Retreat. {t("footer.rights")}</span>
                        <span className="uppercase tracking-widest2">{t("footer.adultsOnly")}</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
